import { Controller, type Control } from "react-hook-form"

import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import type { FilterFormData } from "@/lib/search-filter-model"

interface GeneralFiltersSectionProps {
  control: Control<FilterFormData>
}

export function GeneralFiltersSection({ control }: GeneralFiltersSectionProps) {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 gap-4">
        <div>
          <Label htmlFor="min-experience">Min Experience (Years)</Label>
          <Controller
            name="minExperience"
            control={control}
            render={({ field }) => <Input {...field} id="min-experience" placeholder="0" type="number" />}
          />
        </div>
        <div>
          <Label htmlFor="max-experience">Max Experience (Years)</Label>
          <Controller
            name="maxExperience"
            control={control}
            render={({ field }) => <Input {...field} id="max-experience" placeholder="Example: 10 years" type="number" />}
          />
        </div>
      </div>
    </div>
  )
}
